export default "__VITE_ASSET__Dh5Jdp7d__"